import React, { useState, useEffect, useRef } from 'react';
import './MapMarker.css';
import ActivityCard from '../../../pages/activityMapPage/activityCard/ActivityCard';
import { makeAllIconsInactive, makeIconActive, removeActiveClass } from '../Map';

let MapMarker = (props) => {
	let [open, setOpen] = useState(false);
	let [closing, setClosing] = useState(false);
	let element = useRef(null);

	let checkForOutSideClick = (e) => {
		if (!element) return;
		if (!element.current) return;
		if (!element.current.contains(e.target)) {
			if (open) closeActivity();
		}
	};

	let removeEventListeners = () => {
		document.removeEventListener('mousedown', checkForOutSideClick, false);
		document.removeEventListener('touchstart', checkForOutSideClick, false);
	};

	let listenForClick = () => {
		removeEventListeners();
		document.addEventListener('mousedown', checkForOutSideClick, false);
		document.addEventListener('touchstart', checkForOutSideClick, false);
		document.querySelector('canvas').addEventListener('click', () => {
			if (open) {
				closeActivity();
			}
		});
	};

	useEffect(
		() => {
			if (open) {
				listenForClick();
				makeAllIconsInactive();
				makeIconActive(element.current);
			} else removeEventListeners();
			return () => {
				removeEventListeners();
			};
		},
		[open]
	);

	let closeActivity = () => {
		setClosing(true);
		setTimeout(() => {
			setOpen(false);
			removeActiveClass();
		}, 500);
	};

	let openActivity = () => {
		makeAllIconsInactive();
		makeIconActive(element.current);
		setClosing(false);
		setOpen(true);
	};

	if (open) {
		return <ActivityCard animate closing={closing} ref={element} {...props} />;
	}
	return (
		<div
			ref={element}
			data-type="map-icon"
			data-id={props.id}
			onClick={(e) => {
				props.onClick(e, props.id);
				if (open) closeActivity();
				else openActivity();
			}}
			className={'g-map-marker g-icon ' + props.iconClassName + '  g-lg'}
		/>
	);
};
export default MapMarker;



// WEBPACK FOOTER //
// ./src/components/map/mapMarker/MapMarker.jsx